<template>
  <div>
    <div>
      
      <v-row class="d-flex px-2">
        <v-col :cols="$vuetify.breakpoint.xsOnly ? 0 : 4" class="md-3">
          <v-img 
          :src="one.pictureUrl" 
          :lazy-src="one.pictureLazyUrl" 
          contain height="180px"/>
        </v-col>
        <v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 8" class="md-3">
          <v-radio-group v-model="response" column @change="$emit('save', {response, iso: one.iso})">
            <v-radio v-for="ans in one.answers" :label="ans.label" :value="ans.iso" :key="ans.id"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data: () => ({
    response: ''
  }),
  props: {
    cursor: Number,
    nbQuestions: Number,
    offerIso: String,
    one: Object
  },
  computed: {
    ...mapGetters('project', ['getResponse'])
  },
  mounted () {
    this.response = this.getResponse({iso: this.offerIso, question: this.one.iso})
  }
}
</script>